import { render, staticRenderFns } from "./central-receiving.vue?vue&type=template&id=298ab617&scoped=true&"
import script from "./js/central-receiving.js?vue&type=script&lang=js&"
export * from "./js/central-receiving.js?vue&type=script&lang=js&"
import style0 from "./central-receiving.vue?vue&type=style&index=0&id=298ab617&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ab617",
  null
  
)

export default component.exports